import {graphqlClient} from '@/services/graphqlClient';
import type {GetMyWorkTimeStatusQuery} from '@/services/graphqlHooks';
import {
  useGetMyWorkTimeStatusQuery,
  WorkTimeSessionState,
} from '@/services/graphqlHooks';
import queryClient from '@/services/queryClient';

export const isCurrentWorkTimeSessionActive = async () => {
  const workTimeStatusQuery =
    await queryClient.fetchQuery<GetMyWorkTimeStatusQuery>({
      queryKey: useGetMyWorkTimeStatusQuery.getKey(),
      queryFn: () =>
        graphqlClient.request(useGetMyWorkTimeStatusQuery.document),
    });

  return (
    workTimeStatusQuery.getMyWorkTimeStatus.state ===
    WorkTimeSessionState.Working
  );
};

export default isCurrentWorkTimeSessionActive;
